export enum FirebaseErrorMessage {
  AuthDefault = 'There was an error with this process.',
  AuthEmailAlreadyInUse = 'The email you entered is already registered.',
  AuthInvalidEmail = 'You have entered an invalid email.',
  AuthOperationNotAllowed = 'There was an error with this process.',
  AuthUserDisabled = 'There was an error with this process.',
  AuthUserNotFound = 'You have entered an invalid username or password.',
  AuthWeakPassword = 'The password you entered is not strong enough.',
  AuthWrongPassword = 'You have entered an invalid email or password.'
}
